import { render } from "./SimpleBadge.vue?vue&type=template&id=d26b72f2"
import script from "./SimpleBadge.vue?vue&type=script&lang=js"
export * from "./SimpleBadge.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__